import { z } from "zod";
import { validateAwb } from "../../../../utils";

// Define IFFM Schema (Partial Except s_uld)
export const IFFMSchema = z.object({
    s_uld: z.string().min(1, "ULD is required"), // Ensure ULD is always required
    s_mawb: z.string().min(1, 'MAWB is required').refine(validateAwb, { message: 'Invalid MAWB' }),
    s_origin: z.string().min(1),
    s_destination: z.string().min(1),
    i_actual_piece_count: z.number().min(1),
    f_weight: z.number().min(1),
    s_commodity: z.string().min(1),
    s_special_handling_code: z.string(),
    s_guid: z.string().min(1, "GUID is required"),
    s_created_by: z.string().email().min(1, 'Created by required'),
    t_created: z.date().refine(val => val !== null, { message: 'Created date is required'}),
    s_modified_by: z.string().email().min(1, 'Modified by required'),
    t_modified: z.date().refine(val => val !== null, { message: 'Modified date is required'}),
});

// Define the main schema explicitly
const postDataSchema = z.object({
    united: z.object({
        userId: z.string().min(1, "User ID is required"),
        name: z.string().min(1, "Name is required"),
        scanDateTime: z.date().refine(val => val !== null, { message: 'Scan date/time is required'}),
        scannedCode: z.string(),
        numberOfPiecesInCargo: z.string(),
        scannerId: z.string().min(1, "Scanner ID is required"),
        scannedLoc: z.string(),
    }),
    ffms: z.array(IFFMSchema).min(1, "At least one FFM entry is required"),
    other: z.object({
        s_unit: z.string().min(1, "Unit is required"),
        s_email: z.string().email().min(1, "Email is required"),
        date: z.string().min(1)
    }),
});

// ✅ Explicitly infer the TypeScript type from Zod
type PostDataSchema = z.infer<typeof postDataSchema>;
type IFFMSchemaType = z.infer<typeof IFFMSchema>;

export { postDataSchema };    export type { PostDataSchema, IFFMSchemaType };

